import React from 'react';
import {Grid, Image} from 'semantic-ui-react';

export default (props) => {
    var {image, url} = props;
    return (
        <Grid.Column>
            <Image src={image} className="partner-logo" onClick={url} />
        </Grid.Column>
    )
}


// WEBPACK FOOTER //
// ./src/components/partners/Partner.jsx